import { Button, InputText } from "@sellar-io/components";
import { useForm } from "@tanstack/react-form";
import { SpinnerLegacy } from "../../components";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useBusinessUserUpdate } from "../../hooks/api/v2/businessUser/useBusinessUserUpdate";
import { Alert } from "../alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { DialogCTA } from "../modal/Dialog";

export const BusinessUserJobTitleForm = ({
  businessUserId,
  onDismiss,
  jobTitle,
  onSuccess,
}: {
  businessUserId: number;
  onDismiss: () => void;
  onSuccess?: () => void;
  jobTitle: string | null;
}) => {
  const businessUserUpdateMutation = useBusinessUserUpdate(businessUserId);

  const form = useForm({
    defaultValues: {
      jobTitle: jobTitle ?? "",
    },
    onSubmit: ({ value }) => {
      businessUserUpdateMutation.mutate(
        {
          jobTitle: value.jobTitle,
        },
        {
          onSuccess: () => {
            onDismiss();
            onSuccess?.();
          },
        },
      );
    },
  });

  return (
    <>
      {businessUserUpdateMutation.isPending ? (
        <SpinnerLegacy />
      ) : (
        <>
          {businessUserUpdateMutation.error && (
            <Alert
              type={"error"}
              message={
                apiV2AssertError(businessUserUpdateMutation.error)?.response
                  ?.data.message ?? "Unknown error"
              }
            />
          )}
          <form
            onSubmit={(event) => {
              event.preventDefault();
              event.stopPropagation();
              form.handleSubmit();
            }}
            className={"flex flex-col gap-2"}
          >
            <InputLabel>Job title</InputLabel>
            <InputContainer>
              <form.Field name="jobTitle">
                {(field) => (
                  <InputText
                    name={field.name}
                    value={field.state.value}
                    onBlur={field.handleBlur}
                    onChange={(event) => field.handleChange(event.target.value)}
                  />
                )}
              </form.Field>
            </InputContainer>
            <DialogCTA>
              <Button type="submit">Confirm</Button>
            </DialogCTA>
          </form>
        </>
      )}
    </>
  );
};
